<ambita-report-print-toolbar>
  <div class="ambita-report-print-toolbar">
    <div class="ambita-report-print-toolbar__icon"></div>
    <button class="ambita-report-print-toolbar__button" disabled="{ !printEnabled }"
            type="button" onclick="{ printReport }">
      <span class="ambita-report-print-toolbar__button-text">Print</span>
    </button>
  </div>
  <script>
    import './reportPrintToolbar.scss';
    import { init } from './reportPrintToolbarController';

    init(this);
  </script>
</ambita-report-print-toolbar>
